var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeRoadAb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 88 88",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "#000",
    fillOpacity: 0.4,
    rx: 44
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m40.31 55-2.431-6.592h-8.832L26.615 55H23.03l8.672-22.944h3.584L43.927 55zm-5.695-16.032a15 15 0 0 0-.352-1.056 64 64 0 0 1-.8-2.72q-.256.991-.576 2.112a31 31 0 0 1-.512 1.664L30.07 45.4h6.848zm19.081-6.816q4.352 0 6.592 1.28 2.272 1.28 2.272 4.416 0 2.016-1.088 3.36-1.056 1.313-3.04 1.664v.16q1.344.225 2.432.832a4.4 4.4 0 0 1 1.76 1.728q.64 1.088.64 2.88 0 3.105-2.176 4.832Q58.913 55 55.2 55h-8.192V32.152zm.576 9.536q2.688 0 3.68-.864 1.024-.864 1.024-2.56 0-1.695-1.216-2.432-1.215-.768-3.872-.768h-3.424v6.624zm-3.808 2.816v7.616h4.192q2.753 0 3.84-1.088 1.12-1.087 1.12-2.88 0-1.632-1.152-2.624-1.119-1.024-4.032-1.024z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M50.81 71.236a20.6 20.6 0 0 1-3.234.588 32 32 0 0 1-3.234.176q-5.528 0-10.437-1.968-4.91-1.968-8.733-5.434-3.822-3.465-6.232-8.165Q16.528 51.734 16 46.27h3.586a21.6 21.6 0 0 0 2.411 8.4 25.8 25.8 0 0 0 5.263 6.932c2.137 1.998 7.291 4.847 7.291 4.847l4.985-4.905zM37.19 16.764q1.53-.411 3.24-.588A32 32 0 0 1 43.727 16q5.478 0 10.425 1.968t8.747 5.434 6.214 8.165T72 41.73h-3.534a21.6 21.6 0 0 0-2.415-8.4 25.8 25.8 0 0 0-5.271-6.932c-2.14-1.998-7.304-4.847-7.304-4.847l-4.994 4.905z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeRoadAb);
export default __webpack_public_path__ + "static/media/ChangeRoadAB.1f039a29db7c9c3bf6b753c218b898ca.svg";
export { ForwardRef as ReactComponent };